import { Component } from '@angular/core';
import { ToolBarComponent } from "../../components/tool-bar/tool-bar.component";
import { SharedModule } from 'src/app/private/shared/shared.module';
import { Menu } from 'primeng/menu';
import { LeadService } from 'src/app/private/services/lead.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { MessageService } from 'primeng/api';
import { AcademicYearService } from 'src/app/private/services/acedemicyear.service';
import { CreateAcademicYearComponent } from "../../components/academic-year/create-academic-year/create-academic-year.component";
import { DeleteAcademicYearComponent } from "../../components/academic-year/delete-academic-year/delete-academic-year.component";

@Component({
  selector: 'app-academic-year-configuration',
  imports: [ToolBarComponent, SharedModule, CreateAcademicYearComponent, DeleteAcademicYearComponent],
  templateUrl: './academic-year-configuration.component.html',
  styleUrl: './academic-year-configuration.component.scss'
})
export class AcademicYearConfigurationComponent {

  dataSource: any[] = [];
  totalRecords: number = 0;
  rows: number = 10; // Default page size
  pageSizeOptions = [5, 10, 20, 50];
  initialLoad: boolean = true;
  loading: boolean = false;
  filterArray: any[] = [];
  isAddAcademicYear: boolean = false;
  editLeadFieldData: boolean = false;
  isEditAcademicYear: boolean = false;
  isDeleteAcademicYear: boolean = false;
  academicYearData: any;

  items: any[] = [];

  columns: any[] = [
    { field: 'year_name', header: 'Academic Year Name' },
    { field: 'start_date', header: 'Start Date', type: 'date' },
    { field: 'end_date', header: 'End Date', type: 'date' },
    { field: 'status', header: 'Status' },
    { field: 'actions', header: 'Actions', type: 'actions' }
  ];


  constructor(
    private api: AcademicYearService,
    private localStorage: LocalStorageService,
    private messageService: MessageService
  ) { }




  AcademicYearActionItems: any[] = [
    {
      label: 'Options',
      items: [
        {
          label: 'Edit Academic Year',
          icon: 'pi pi-fw pi-pencil',
          command: () => {
            this.isEditAcademicYear = true;
          }
        },
        {
          label: 'Delete Academic Year',
          icon: 'pi pi-fw pi-trash',
          styleClass: 'delete-menu-item',
          command: () => {
            this.isDeleteAcademicYear = true;
          }
        }
      ]
    }
  ]


  setAcademicYearEditData(rowData: any) {
    this.academicYearData = rowData;
  }


  loadData(event: any) {
    const page = event.first || 0;
    const size = event.rows || this.rows;

    const param = {
      "where": {
        "organization_id": this.localStorage.getOrganizationId(),
        "campus_id": this.localStorage.getCampusId()
      },
      "filter": null,
      "page": page,
      "limit": size,
      "order": {
        "col": "\"academic_year\".\"updatedAt\"",
        "dir": "DESC"
      }
    }

    this.loading = true;

    this.api.getAllAcademicYearsWithCount(param).subscribe({
      next: (data) => {
        this.dataSource = data.rows || [];
        this.totalRecords = data.count || 0;
        this.loading = false;
      },
      error: () => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to load academic years.' });
        this.initialLoad = false;
        this.loading = false;
      },
    });
  }

  reloadData() {
    this.loadData({ first: 0, rows: this.rows });
  }

  handleAcadmicYear() {
    this.isAddAcademicYear = true;
  }

  handleCloseDialog() {
    this.isAddAcademicYear = false;
  }


}
